module.exports = __webpack_public_path__ + "static/media/BattleOfBrooklyn.96a7cba1.gif";